import endpoints from "../utils/endpoints";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";


export async function getBingoConfiguration(){
    let res = {
        maximum_wait: "",
        minimum_wait: "",
        max_players: "",
        display_ssn: ""
    };

    await Api.get(endpoints.getBingoConfig).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Error on getting bingo configuration')
    })
    
    return res
}

export async function updateBingoConfiguration(params: any){

    await Api.post(endpoints.updateBingoConfig, null, {params}).then((response) => {
      if(response.status === 200 || response.data.return) {
          if(response.data.error) {
              notificationError(`${response.data.message}`)
          } else {
              notificationSucces('Bingo configuration changed successfully')
          }
      } else {
        notificationError('Could not update bingo configuration')
      }
    }).catch((err: string) => {
        notificationError('Could not update bingo configuration')
    })
}

